var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"text-small",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.course)+" by "+_vm._s(_vm.teacher)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }